import React from 'react';

const AboutPage = () => {
    return (
        <div>
            <h1>About page </h1>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porttitor eleifend enim, quis pretium nibh. Integer in accumsan felis. Aenean vitae sodales felis. Phasellus euismod sem felis, sagittis pharetra tortor venenatis laoreet. Nunc eget leo tincidunt, aliquam elit quis, pharetra metus. Etiam tincidunt nisi in dignissim auctor. Morbi elementum et elit id commodo. Quisque ac ante molestie, accumsan dolor suscipit, rutrum metus. Nulla sed vehicula sem, id dictum eros. Fusce vitae augue pretium, fermentum mi sit amet, dignissim orci. Sed fringilla quam nulla, vel tempus ipsum tincidunt sed. In sit amet finibus tellus.


            </p>
        </div>
    )
}

export default AboutPage;